<template>
    <Tooltip :text="props.tooltip || 'Share'" position="left">
        <div class="cursor-pointer size-7 text-indigo-600 dark:text-indigo-400 hover:rounded-full hover:bg-gray-200 dark:hover:bg-slate-700 p-1 transition-all duration-300 flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z" />
            </svg>
        </div>
    </Tooltip>
</template>
<script setup>
import { defineProps } from 'vue';
import Tooltip from '@/components/common/elements/TriadTooltip.vue';

const props = defineProps({
    tooltip: {
        type: String,
        default: 'Share'
    }
});
</script>
